// extracted by mini-css-extract-plugin
export default {"container":"Client_container__3-vzA"};